export default __webpack_public_path__ + "static/media/cbs-logo.6d68a15a.png";